/* # FileViewerModal Component
   - Lightbox for viewing images, PDFs, and Office documents
   - Removed download button as requested by user due to inconsistent browser behavior
*/
import { LuX, LuExternalLink, LuFileText } from 'react-icons/lu';

export default function FileViewerModal({ url, fileName, type, onClose }) {
  if (!url) return null;

  const isImage = type === 'image';
  const isPdf = type === 'pdf';
  const isOffice = ['spreadsheet', 'document'].includes(type);

  // Use Office Online Viewer for DOCX, XLSX, etc.
  const viewerUrl = isOffice ?
  `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(url)}` :
  url;

  return (
    <div className="fixed inset-0 bg-black/95 backdrop-blur-md z-[100] flex flex-col animate-in fade-in duration-300">
      {/* Header */}
      <div className="flex items-center justify-between p-4 bg-black/40 border-b border-white/10 shrink-0">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-white/10 rounded-lg">
            <LuFileText className="w-5 h-5 text-white" />
          </div>
          <div className="min-w-0">
            <h3 className="text-white font-bold truncate max-w-[200px] sm:max-w-md">{fileName}</h3>
            <p className="text-[10px] text-white/50 font-bold uppercase tracking-widest">
              {type} Viewer
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="p-2 text-white/70 hover:text-white hover:bg-white/10 rounded-full transition-all"
            title="Open in new tab">

            <LuExternalLink className="w-5 h-5" />
          </a>
          <div className="w-px h-6 bg-white/10 mx-1" />
          <button
            onClick={onClose}
            className="p-2 text-white/70 hover:text-white hover:bg-red-500 rounded-full transition-all">

            <LuX className="w-6 h-6" />
          </button>
        </div>
      </div>

      {/* Viewer Content */}
      <div className="flex-1 relative w-full h-full flex items-center justify-center overflow-hidden">
        {isImage ?
        <div className="w-full h-full flex items-center justify-center p-4">
          <img
            src={url}
            alt={fileName}
            className="max-w-full max-h-full object-contain shadow-2xl animate-in zoom-in duration-500" />
        </div> :

        isPdf || isOffice ?
        <div className="w-full h-full bg-white shadow-2xl overflow-y-auto relative">
            <iframe
            src={viewerUrl}
            className="w-full h-full border-none block"
            title="File Viewer" />

          </div> :

        <div className="text-center space-y-4 p-4">
            <div className="w-20 h-20 bg-white/10 rounded-3xl flex items-center justify-center mx-auto">
              <LuFileText className="w-10 h-10 text-white/40" />
            </div>
            <p className="text-white font-medium">This file type cannot be previewed directly.</p>
            <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-white text-black rounded-xl font-bold hover:bg-gray-200 transition-all">

              <LuExternalLink className="w-5 h-5" />
              Open File
            </a>
          </div>
        }
      </div>
    </div>);
}